import axiosInstance from "../../../../../shared/api/axiosInstance.js";
import { baseUrl, SINGLE_USER, EDIT_USER, EDIT_USER_AVATAR } from "../../../../../shared/api/endpoints.js";
import { configReq } from "../../../../../shared/lib/functions.js";
/** Keeps the existing GET request and response contract. */
export function singleUser(id, token) {
  return axiosInstance(`${baseUrl}/${SINGLE_USER}?id=${id}`, configReq(token));
}

/** Keeps the existing PUT request and response contract. */
export function editUser(temp, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_USER}`, {
    ...temp,
    accessId: temp?.accessId !== -1 ? temp.accessId : null
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data"
    }
  });
}

/** Keeps the existing PUT request and response contract. */
export function editUserAvatar(formData, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_USER_AVATAR}`, formData, configReq(token));
}
